import { Brush, Eraser, Lasso, PenTool, SquareDashed, WandSparkles } from 'lucide-react';

export const EDIT_IMAGE_METHOD = {
  STYLE: 'style',
  MAGIC: 'magic',
} as const;
type EDIT_IMAGE_METHOD_KEYS = keyof typeof EDIT_IMAGE_METHOD;
export type TYPE_EDIT_IMAGE_METHOD = (typeof EDIT_IMAGE_METHOD)[EDIT_IMAGE_METHOD_KEYS];

export const MAGIC_TOOL_OPTIONS = {
  BRUSH: 'brush',
  ERASER: 'eraser',
  LASSO: 'lasso',
  PEN: 'pen',
  RECTANGLE_MARQUEE: 'reactangle_marquee',
  MAGIC_WAND: 'magic_wand',
} as const;
type MAGIC_TOOL_OPTIONS_KEYS = keyof typeof MAGIC_TOOL_OPTIONS;
export type TYPE_MAGIC_TOOL_OPTIONS = (typeof MAGIC_TOOL_OPTIONS)[MAGIC_TOOL_OPTIONS_KEYS];

export const editMethodOptions = [
  {
    label: 'style',
    value: EDIT_IMAGE_METHOD.STYLE,
  },
  {
    label: 'magic',
    value: EDIT_IMAGE_METHOD.MAGIC,
    disabled: true,
  },
];

export const magicToolOptions = [
  {
    icon: Brush,
    value: MAGIC_TOOL_OPTIONS.BRUSH,
  },
  {
    icon: Eraser,
    value: MAGIC_TOOL_OPTIONS.ERASER,
  },
  {
    icon: Lasso,
    value: MAGIC_TOOL_OPTIONS.LASSO,
  },
  {
    icon: PenTool,
    value: MAGIC_TOOL_OPTIONS.PEN,
  },
  {
    icon: SquareDashed,
    value: MAGIC_TOOL_OPTIONS.RECTANGLE_MARQUEE,
  },
  {
    icon: WandSparkles,
    value: MAGIC_TOOL_OPTIONS.MAGIC_WAND,
  },
];
